import type { APIGetSlipResponse } from '../interfaces/propsService/api';
import type { TGetSlipResponse } from '../interfaces/propsService/parsed/slips';

import { parseSlip } from './parseSlip';

export const parseSlipResponse = (response: APIGetSlipResponse): TGetSlipResponse => ({
  ...response,
  slip: parseSlip(response.slip),
});
